import { types } from './types';
import { instance } from '../utils';
import { triggerNotification } from '../../components';
import { triggerLoading } from '../forms/actions';
import { getDocumentsByLaws } from '../documents/actions';

export const getLawsByUserAndOrg = (user, orgId) => dispatch => {
  const url = `/api/laws/lawsByUserAndOrg`;
  const headers = {
    "Content-Type": "application/json",
    'Authorization': `Bearer ${user.token}`
  }
  const payload = {
    userId: user.userId,
    orgId: orgId,
  }
  dispatch(triggerLoading(true));
  dispatch({ type: types.SET_LAWS.START });
  instance
  .post(url, payload , { headers })
  .then(response => {
    dispatch({ type: types.SET_LAWS.SUCCESS, payload: response.data });
    dispatch(getDocumentsByLaws(user, orgId));
  })
  .catch(error => {
    dispatch({ type: types.SET_LAWS.ERROR, payload: error.message });
    triggerNotification({
      message: "Error",
      description: error.message,
      status: 'Error',
    });
  })
  .finally(() =>
    dispatch(triggerLoading(false))
  )
}

export const createLaw = ({user, payload, callback}) => dispatch => {
  const url = `/api/laws/`;
  const headers = {
    'Content-Type': 'multipart/form-data; charset=utf-8',
    'Authorization': `Bearer ${user.token}`
  }
  dispatch(triggerLoading(true));
  dispatch({ type: types.CREATE_LAW.START });
  instance
  .post(url, payload, { headers })
  .then(response => {
    dispatch({ type: types.CREATE_LAW.SUCCESS, payload: response.data?.law });
    dispatch(getLawsByUserAndOrg(user, user.organization));
    console.debug(response.data?.emails)
    callback(response.data?.emails ?? [], true);
  })
  .catch(error => {
    dispatch({ type: types.CREATE_LAW.ERROR, payload: error.message });
    callback([], false);
    triggerNotification({
      message: "Error",
      description: error.message,
      status: 'Error',
    });
  })
  .finally(() =>
    dispatch(triggerLoading(false))
  )
}

export const checkLawEditability = ({user, id, action, callback}) => dispatch => {
  const url = `/api/laws/${id}/${action}/checkLaw`;
  const headers = {
    "Content-Type": "application/json",
    'Authorization': `Bearer ${user.token}`
  }
  dispatch({ type: types.CHECK_LAW.START });
  instance
  .get(url, { headers })
  .then(response => {
    dispatch({ type: types.CHECK_LAW.SUCCESS, payload: response.status});
    callback(response.status);
    })
  .catch(error => {
    dispatch({ type: types.CHECK_LAW.ERROR, payload: error.message });
    triggerNotification({
      message: "Error",
      description: error.message,
      status: 'Error',
    });
  })
  
}

export const updateLaw = (user, id, orgId, payload) => dispatch => {
  const url = `/api/laws/${id}`;
  const headers = {
    "Content-Type": "application/json",
    'Authorization': `Bearer ${user.token}`
  }
  dispatch({ type: types.UPDATE_LAW.START });
  instance
  .patch(url, payload, { headers })
  .then(response => {
    dispatch({ type: types.UPDATE_LAW.SUCCESS });
    triggerNotification({});
    dispatch(getLawsByUserAndOrg(user, orgId));
  })
  .catch(error => {
    dispatch({ type: types.UPDATE_LAW.ERROR, payload: error.message });
    triggerNotification({
      message: "Error",
      description: error.message,
      status: 'Error',
    });
  });
}

export const deleteLaw = (user, id) => dispatch => {
  const url = `/api/laws/${id}`;
  const headers = {
    "Content-Type": "application/json",
    'Authorization': `Bearer ${user.token}`
  }
  dispatch({ type: types.DELETE_LAW.START });
  instance
  .delete(url, { headers })
  .then(response => {
    // dispatch({ type: types.DELETE_LAW.SUCCESS, payload: response });
    triggerNotification({});
    dispatch(getLawsByUserAndOrg(user, user.organization));
  })
  .catch(error => {
    dispatch({ type: types.DELETE_LAW.ERROR, payload: error.message });
    triggerNotification({
      message: "Error",
      description: error.message,
      status: 'Error',
    });
  });
}


